import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { InputTextFieldRHF } from "@/components/ui/form/fields-rhf/input-field/input-text";

import { useGoogleFreeBookingLinksSettingsI18nContext } from "../../../_context";

export const FormAddress = () => {
	const { form } = useGoogleFreeBookingLinksSettingsI18nContext();
	const {
		register,
		formState: { errors },
	} = form;

	return (
		<QuestionForMain
			title={"住所"}
			required
			inputChildren={
				<div className="flex flex-col gap-6">
					<div className="flex flex-col gap-2">
						<InputTextFieldRHF
							label="郵便番号"
							errorMessage={errors?.address?.postalCode?.message}
							{...register("address.postalCode")}
						/>

						<InputTextFieldRHF
							label="都道府県"
							errorMessage={errors?.address?.province?.message}
							{...register("address.province")}
						/>

						<InputTextFieldRHF
							label="市区町村"
							errorMessage={errors?.address?.city?.message}
							{...register("address.city")}
						/>

						<InputTextFieldRHF
							label="市区町村以降（任意）"
							errorMessage={errors?.address?.addr1?.message}
							{...register("address.addr1")}
						/>
					</div>
				</div>
			}
		/>
	);
};
